import React from "react"
import { MpLoader } from "../../../mp-shared-components/ready-shared-components/components/mpLoader"
import { useDelayedAnnounce } from "@masteryprep/mp-shared-components/generic"

// a11y: how long a route chunk must still be downloading before we announce a
// generic status; a fast load unmounts this loader first and stays silent.
const LOADING_ANNOUNCE_DELAY_MS = 1000

const LazyLoader = () => {
  return (
    <div className="route-loader">
      <MpLoader />
    </div>
  )
}
export const MainContentLazyLoader = () => {
  // a11y: speak only when the chunk download runs long (e.g. 3G); the destination's
  // own loader then announces the specific "Loading {page}".
  useDelayedAnnounce("Loading…", LOADING_ANNOUNCE_DELAY_MS)
  return (
    <div className="route-loader-m">
      <MpLoader />
    </div>
  )
}
export const QuestionContentLazyLoader = () => {
  return (
    <div className="route-loader-m">
      <MpLoader height={"3"} width={"5"} />
    </div>
  )
}

export default LazyLoader
